<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap align-center>
      <v-flex xs12 sm8>
        <h2 class="headline">User Activity</h2>
        <div class="grey--text body-1">
          Portal users across all organisations. "Last active" is recorded since 8 Oct 2026 (once a day, on first use);
          "Last login" only changes when a password is typed.
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="text-sm-right">
        <v-btn flat color="primary" :loading="loading" @click="load">
          <v-icon left>refresh</v-icon>Refresh
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex xs12 sm3>
        <v-select :items="filters" v-model="filter" label="Show"></v-select>
      </v-flex>
      <v-flex xs12 sm3>
        <v-select :items="organisations" v-model="organisation" label="Organisation" clearable></v-select>
      </v-flex>
      <v-flex xs12 sm6>
        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
      </v-flex>
    </v-layout>

    <div class="grey--text caption mb-2">{{ shown.length }} of {{ users.length }} users</div>

    <v-data-table :headers="headers" :items="shown" :search="search" :loading="loading"
                  :rows-per-page-items="[25, 50, 100, 500]" class="elevation-1">
      <template v-slot:items="props">
        <td>{{ props.item.name }} {{ props.item.surname }}</td>
        <td>{{ props.item.emailAddress }}</td>
        <td>{{ props.item.organisations }}</td>
        <td>{{ formatDate(props.item.lastActivity) }}</td>
        <td>{{ formatDate(props.item.lastLogin) }}</td>
        <td>{{ formatDate(props.item.createdAt) }}</td>
        <td>{{ props.item.isActive ? 'Yes' : 'No' }}</td>
      </template>
    </v-data-table>

    <v-snackbar v-model="snack" :timeout="4000">{{ snackText }}</v-snackbar>
  </v-container>
</template>

<script>
import Api from "@/services/Api";

const DAY = 24 * 60 * 60 * 1000;

export default {
  name: "UserActivity",
  data() {
    return {
      users: [],
      loading: false,
      search: "",
      organisation: null,
      filter: "All users",
      filters: [
        "All users",
        "Active in the last 30 days",
        "No login and no activity in 3 months",
        "Never logged in"
      ],
      headers: [
        { text: "Name", value: "name" },
        { text: "Email", value: "emailAddress" },
        { text: "Organisations", value: "organisations" },
        { text: "Last active", value: "lastActivity" },
        { text: "Last login", value: "lastLogin" },
        { text: "Created", value: "createdAt" },
        { text: "Active", value: "isActive" }
      ],
      snack: false,
      snackText: ""
    };
  },
  computed: {
    organisations() {
      const set = {};
      this.users.forEach(u => (u.organisations || "").split(", ").forEach(o => { if (o) set[o] = true; }));
      return Object.keys(set).sort();
    },
    shown() {
      const now = Date.now();
      const latest = u => Math.max(u.lastActivity ? new Date(u.lastActivity).getTime() : 0,
                                   u.lastLogin ? new Date(u.lastLogin).getTime() : 0);
      return this.users.filter(u => {
        if (this.organisation && (u.organisations || "").split(", ").indexOf(this.organisation) === -1) return false;
        if (this.filter === "Active in the last 30 days") return latest(u) >= now - 30 * DAY;
        if (this.filter === "No login and no activity in 3 months") return latest(u) < now - 91 * DAY;
        if (this.filter === "Never logged in") return !u.lastLogin && !u.lastActivity;
        return true;
      });
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      Api()
        .get("/admin/userActivity")
        .then(response => {
          this.users = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          this.notify("Could not load users.");
        });
    },
    formatDate(value) {
      if (!value) return "-";
      return new Date(value).toLocaleString("en-ZA");
    },
    notify(text) {
      this.snackText = text;
      this.snack = true;
    }
  }
};
</script>
